import { createContext, useContext, useState, FC, ReactNode } from 'react';

type MenuGroupState = {
  openId: string | null;
  setOpenId: (id: string | null) => void;
};

const MenuGroupContext = createContext<MenuGroupState>({
  openId: null,
  setOpenId: () => {},
});

export function useMenuGroup() {
  return useContext(MenuGroupContext);
}

type ProviderProps = {
  children: ReactNode;
  defaultOpenId?: string | null;
};

export const MenuGroupProvider: FC<ProviderProps> = ({ children, defaultOpenId = null }) => {
  const [openId, setOpenId] = useState<string | null>(defaultOpenId);
  return (
    <MenuGroupContext.Provider value={{ openId, setOpenId }}>
      {children}
    </MenuGroupContext.Provider>
  );
};
